import axios from "axios";

const get = () => axios.get("api/v1/settings/incomplete-tasks-reminder");

const update = (payload) =>
  axios.put("api/v1/settings/incomplete-tasks-reminder", payload);

const ApiIncompleteTasksReminder = {
  get,
  update,
};

export default ApiIncompleteTasksReminder;
